<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="container" *ngIf="order && !isLoading; else noOrder">
    <div class="top-section">
        <mat-icon class="icon" *ngIf="!isFromMail" (click)="goBack()">arrow_back</mat-icon>
        <p class="heading">{{ "orderDetailInfo.orderDetails" | translate }}</p>
    </div>

    <div class="middle-section">
        <div class="middle-section-left-container">
            <div class="middle-section-left">
                <span
                    >{{ "orderDetailInfo.orderId" | translate }} : #
                    <strong>{{ order.id }}</strong>
                </span>
                <span class="divider"></span>
                <span class="order-status-date">{{ order.updatedAt | date: "dd MMM YYYY" }}</span>
            </div>
        </div>
        <div class="help-btn-container">
            <app-button variant="outline" buttonClass="explore-btn" (click)="openHelpDialog()">
                <mat-icon>headset_mic</mat-icon>{{ "orderStatus.help" | translate }}
            </app-button>
        </div>
    </div>
    <div class="item-container-section">
        <!-- To notify exchange or return info  -->
        <div class="info" *ngIf="order.orderStatus !== OrderStatus.Pending && order.orderStatus !== OrderStatus.Failed">
            <mat-icon>info</mat-icon>
            <p>{{ "order.orderDetails.notifyMessage" | translate }}</p>
        </div>
        <!-- end -->
        @for (item of order.orderItems; track $index) {
        <div class="item-section">
            <div class="image-details-container">
                <img class="item-image" [src]="item.product?.images?.imagesUrl?.[0]" />
                <div class="item-status-section">
                    <strong class="product-name">{{ item.product?.name }}</strong>
                    <p>
                        Quantity: <span>{{ item.quantity }}</span>
                    </p>

                    <p *ngIf="item.itemStatus">
                        <span>{{ "orderDetailInfo.orderStatus" | translate }}: </span>
                        <span
                            [ngClass]="{
                                failed: item.itemStatus === OrderStatus.Failed,
                                pending: item.itemStatus === OrderStatus.Pending,
                                ordered: item.itemStatus === OrderStatus.Ordered,
                                packed: item.itemStatus === OrderStatus.Packed,
                                cancelled: item.itemStatus === OrderStatus.Cancelled,
                                dispatched: item.itemStatus === OrderStatus.Dispatched,
                                delivered: item.itemStatus === OrderStatus.Delivered,
                                returnInitiated: item.itemStatus === OrderStatus.ReturnInitiated,
                                pickupScheduled: item.itemStatus === OrderStatus.PickupScheduled,
                                returned: item.itemStatus === OrderStatus.Returned,
                                exchangeInitiated: item.itemStatus === OrderStatus.ExchangeInitiated,
                                exchangePacked: item.itemStatus === OrderStatus.ExchangePacked,
                                exchangeDispatched: item.itemStatus === OrderStatus.ExchangeDispatched,
                                exchanged: item.itemStatus === OrderStatus.Exchanged
                            }"
                        >
                            {{ item.itemStatus }}
                        </span>
                    </p>
                    <p *ngIf="item.refund?.refundStatus">
                        <span>{{ "orderDetailInfo.refundStatus" | translate }}: </span>
                        <span class="refund-successful">{{ item.refund?.refundStatus }}</span>
                    </p>
                </div>

                <!-- Block Configuration -->
                <div class="block-item-info-container" *ngIf="item.singleBlockInfoDirectBuy">
                    <!-- Node / Hole Configuration -->
                    <div class="node-hole-plane-config">
                        <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config">
                            <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Plane") }}</span>
                        </div>

                        <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config">
                            <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Hole") }}</span>
                        </div>

                        <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config">
                            <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                            <span class="block-face-value">{{ getFacesByType(item, "Node") }}</span>
                        </div>
                    </div>
                    <!-- End -->
                    <!-- Color Configuration -->
                    <div class="color-config">
                        <div class="color-info">
                            <div *ngFor="let color of getFaceColors(item.singleBlockInfoDirectBuy?.color)">
                                <div class="color-item">
                                    <div
                                        class="color-box"
                                        [ngStyle]="{ 'background-color': getColorValue(color.value) }"
                                    ></div>
                                    <div class="color-name">
                                        <span class="block-face-label">{{ color.key }} </span>
                                        <span class="block-face-value">
                                            {{ color.value }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END -->
                </div>
                <!-- Block End -->
            </div>
            <!-- Track Button  -->
            <div class="track-container" *ngIf="!isTrackbuttonOn">
                <app-button
                    variant="white"
                    buttonClass="shadow-btn"
                    (click)="navigateOrderPage(order.id, item.productId)"
                >
                    Track<mat-icon>chevron_right</mat-icon>
                </app-button>
            </div>
        </div>
        }
    </div>

    <div class="bottom-section">
        <!-- Invoice Button -->
        <div class="invoice-text">
            <app-button variant="green" download> <mat-icon>download</mat-icon> Download Invoice </app-button>
        </div>

        <div class="order-details">
            <!-- Shipping Section -->
            <div class="ship-section">
                <div class="label-section">
                    <span>{{ "orderDetailInfo.shipTo" | translate }}</span>
                </div>

                <div class="value-section">
                    <span
                        >{{ order.orderAddress?.shippingAddress?.houseNumber }},
                        {{ order.orderAddress?.shippingAddress?.address }}</span
                    >
                    <span
                        >{{ order.orderAddress?.shippingAddress?.city }},
                        {{ order.orderAddress?.shippingAddress?.state }}</span
                    >
                    {{ order.orderAddress?.shippingAddress?.pincode }}
                </div>
            </div>
            <!-- Payment Section -->
            <div class="payment-section">
                <div class="label-section">
                    {{ "orderDetailInfo.paymentMethods" | translate }}
                </div>

                <div class="value-section">
                    <span>{{ order.paymentMethod }}</span>
                    <p *ngIf="order.paymentStatus">
                        {{ "orderDetailInfo.paymentStatus" | translate }}:
                        <span
                            [ngClass]="{
                                pending: order.paymentStatus === PaymentStatus.Pending,
                                success: order.paymentStatus === PaymentStatus.Success,
                                failed: order.paymentStatus === PaymentStatus.Failed
                            }"
                        >
                            {{ order.paymentStatus }}
                        </span>
                    </p>
                    <p *ngIf="refundStatusMessage(order) === RefundStatus.RefundSuccessful">
                        {{ "orderDetailInfo.refundStatus" | translate }}:
                        <span class="refund-successful">
                            {{ refundStatusMessage(order) }}
                        </span>
                    </p>
                </div>
            </div>
            <!-- Price Details -->
            <div class="price-section">
                <div class="label-section">
                    {{ "orderDetailInfo.priceDetails" | translate }}
                </div>

                <div class="value-section">
                    <p class="order-info">
                        <span>{{ "orderInfo.orderDetails.subTotal" | translate }} : </span>
                        <span
                            >{{ "orderInfo.currency.rs" | translate }}
                            {{ isOrderFullyCancelledOrReturned ? order.originalSubTotal : order.currentSubTotal }}</span
                        >
                    </p>
                    <p class="order-info">
                        <span>{{ "orderInfo.orderDetails.couponDiscount" | translate }} : </span>
                        <span
                            >- {{ "orderInfo.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned
                                    ? order.originalCouponDiscount
                                    : order.currentCouponDiscount
                            }}</span
                        >
                    </p>
                    <p class="order-info">
                        <span>{{ "orderInfo.orderDetails.shipping" | translate }} : </span>
                        <span>+ {{ "orderInfo.currency.rs" | translate }} {{ order.deliveryCharge }}</span>
                    </p>
                    <p class="order-info total-amount">
                        <span>{{ "orderInfo.orderDetails.total" | translate }} : </span>
                        <span
                            >{{ "orderInfo.currency.rs" | translate }}
                            {{ isOrderFullyCancelledOrReturned ? order.originalTotal : order.currentTotal }}</span
                        >
                    </p>
                    <p class="order-info">
                        <span>{{ "orderInfo.orderDetails.coinsUsed" | translate }} : </span>
                        <span
                            >{{ "orderInfo.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned ? order.originalCoinsUsed : order.currentCoinsUsed
                            }}</span
                        >
                    </p>
                    <p class="order-info payable-amount">
                        <span
                            >{{
                                (order.paymentMethod === PaymentMethod.CashOnDelivery &&
                                (order.orderStatus === OrderStatus.Ordered ||
                                    order.orderStatus === OrderStatus.Packed ||
                                    order.orderStatus === OrderStatus.Dispatched ||
                                    order.orderStatus === OrderStatus.Cancelled)
                                    ? "order.orderDetails.payableAmount"
                                    : "order.orderDetails.amountCharged"
                                ) | translate
                            }}
                            :
                        </span>
                        <span
                            >{{ "orderInfo.currency.rs" | translate }}
                            {{
                                isOrderFullyCancelledOrReturned
                                    ? order.originalPaymentAmount
                                    : order.currentPaymentAmount
                            }}</span
                        >
                    </p>

                    <p
                        class="order-info refund-amount"
                        *ngIf="refundStatusMessage(order) === RefundStatus.RefundSuccessful"
                    >
                        <span class="refund-successful">Refunded Amount:</span>
                        <span class="refund-successful">Rs. {{ refundAmount }} </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #noOrder class="no-order-container">
    <app-no-order-item></app-no-order-item>
</ng-template>
